interface Props {
  portfolioName: string;
  currencyISO: string;
  isWatchlist: boolean;
  portfolioWithNoTransactions: boolean;
  annualReturn: number;
  portfolioYearAge: number;
  annualReturnFormatted: string;
  totalDividendReturnFormatted: string;
}

const ExecutiveSummaryIntroduction = ({
  portfolioName,
  currencyISO,
  isWatchlist,
  portfolioWithNoTransactions,
  annualReturn,
  portfolioYearAge,
  annualReturnFormatted,
  totalDividendReturnFormatted,
}: Props) => (
  <p data-cy-id="portfolio-summary-desc">
    {portfolioName} is a {currencyISO} {isWatchlist ? 'watchlist' : 'portfolio'}
    {` `}
    that has returned{` `}
    {isWatchlist || portfolioWithNoTransactions
      ? `${totalDividendReturnFormatted} in the past year.`
      : annualReturn !== null && annualReturn > 0 && portfolioYearAge > 1
        ? `${annualReturnFormatted} annually since inception.`
        : `${totalDividendReturnFormatted} since inception.`}
  </p>
);

export default ExecutiveSummaryIntroduction;
